export const printError = (err) => console.error(err)
